import Haematology from './Haematology';

export default Haematology;
